import { SvgIcon, SxProps } from "@mui/material";
import ArrowLeftSvg from "jsx:../../../Images/Icons/FontAwesome/light/arrow-left.svg";

export function ArrowLeftIcon(props: SxProps) {
    return <SvgIcon component={ArrowLeftSvg} inheritViewBox sx={props} />;
}
